import { updateView, viewParams } from './update-view.js'

export function showTableGroupContacts (groupContactsResponse, entities) {
  console.log('showTableGroupContacts', groupContactsResponse)

  viewParams.groupContactsResponse = groupContactsResponse
  viewParams.entities = entities
  updateView()
}
